export var POPUP_CONNECTION_STATE = /*#__PURE__*/function (POPUP_CONNECTION_STATE) {
  POPUP_CONNECTION_STATE["alreadyInUse"] = "alreadyInUse";
  POPUP_CONNECTION_STATE["houseIsNotFound"] = "houseIsNotFound";
  POPUP_CONNECTION_STATE["isAvailable"] = "isAvailable";
  POPUP_CONNECTION_STATE["isConnected"] = "isConnected";
  POPUP_CONNECTION_STATE["isExists"] = "isExists";
  POPUP_CONNECTION_STATE["isNone"] = "isNone";
  POPUP_CONNECTION_STATE["isNotAvailable"] = "isNotAvailable";
  POPUP_CONNECTION_STATE["regionIsNotConnect"] = "regionIsNotConnect";
  POPUP_CONNECTION_STATE["regionIsNotFound"] = "regionIsNotFound";
  POPUP_CONNECTION_STATE["streetIsNotFound"] = "streetIsNotFound";
  POPUP_CONNECTION_STATE["isHighSpeedAvailableWithoutCalendarStep"] = "isHighSpeedAvailableWithoutCalendarStep";
  POPUP_CONNECTION_STATE["speedLimit"] = "speedLimit";
  POPUP_CONNECTION_STATE["success"] = "success";
  POPUP_CONNECTION_STATE["notFound"] = "notFound";
  POPUP_CONNECTION_STATE["checkAddress"] = "checkAddress";
  POPUP_CONNECTION_STATE["fail"] = "fail";
  POPUP_CONNECTION_STATE["highSpeedAvailable"] = "highSpeedAvailable";
  return POPUP_CONNECTION_STATE;
}({});
export var CHECK_HOUSE_CONNECTION_STATUS = /*#__PURE__*/function (CHECK_HOUSE_CONNECTION_STATUS) {
  CHECK_HOUSE_CONNECTION_STATUS["HasConnectionOnAddress"] = "HasConnectionOnAddress";
  CHECK_HOUSE_CONNECTION_STATUS["HasTicketOnAddress"] = "HasTicketOnAddress";
  CHECK_HOUSE_CONNECTION_STATUS["IsNotAvailable"] = "IsNotAvailable";
  CHECK_HOUSE_CONNECTION_STATUS["IsAvailable"] = "IsAvailable";
  CHECK_HOUSE_CONNECTION_STATUS["IsHighSpeedAvailable"] = "IsHighSpeedAvailable";
  CHECK_HOUSE_CONNECTION_STATUS["NotFound"] = "NotFound";
  CHECK_HOUSE_CONNECTION_STATUS["SpeedLimit"] = "SpeedLimit";
  CHECK_HOUSE_CONNECTION_STATUS["CheckAddress"] = "CheckAddress";
  return CHECK_HOUSE_CONNECTION_STATUS;
}({});
export var EXISTS_STATUSES = [POPUP_CONNECTION_STATE.alreadyInUse, POPUP_CONNECTION_STATE.isExists];
export var NOTIFICATION_AVAILABLE_STATUSES = [CHECK_HOUSE_CONNECTION_STATUS.IsNotAvailable, CHECK_HOUSE_CONNECTION_STATUS.CheckAddress, CHECK_HOUSE_CONNECTION_STATUS.SpeedLimit];
export var CALLBACK_CONNECTED_STATUSES = [CHECK_HOUSE_CONNECTION_STATUS.HasTicketOnAddress, CHECK_HOUSE_CONNECTION_STATUS.NotFound, CHECK_HOUSE_CONNECTION_STATUS.HasConnectionOnAddress];
export var AVAILABLE_STATUSES = [POPUP_CONNECTION_STATE.isAvailable, POPUP_CONNECTION_STATE.highSpeedAvailable];
export var AVAILABLE_INLINE_STATUSES = [CHECK_HOUSE_CONNECTION_STATUS.IsAvailable];
export var popupSteps = /*#__PURE__*/function (popupSteps) {
  popupSteps[popupSteps["addressRequestForm"] = 0] = "addressRequestForm";
  popupSteps[popupSteps["alternativeTariff"] = 1] = "alternativeTariff";
  popupSteps[popupSteps["shortSuccess"] = 2] = "shortSuccess";
  popupSteps[popupSteps["fail"] = 3] = "fail";
  popupSteps[popupSteps["addressNotAvailableModal"] = 4] = "addressNotAvailableModal";
  popupSteps[popupSteps["alreadyInUse"] = 5] = "alreadyInUse";
  return popupSteps;
}({});
export var orderTariffPopupNames = {
  addressRequestForm: 'addressRequestForm',
  alternativeTariff: 'alternativeTariff',
  shortSuccess: 'shortSuccess',
  fail: 'fail',
  addressNotAvailableModal: 'addressNotAvailableModal',
  alreadyInUse: 'alreadyInUse',
  isExist: 'isExist'
};
export var orderTariffPopupSteps = [orderTariffPopupNames.addressRequestForm, orderTariffPopupNames.alternativeTariff, orderTariffPopupNames.shortSuccess, orderTariffPopupNames.fail, orderTariffPopupNames.addressNotAvailableModal, orderTariffPopupNames.alreadyInUse, orderTariffPopupNames.isExist];
export var POPUP_STATE = {
  addressRequestForm: 'addressRequestForm',
  alternativeTariff: 'alternativeTariff',
  shortSuccess: 'shortSuccess',
  fail: 'fail',
  addressNotAvailableModal: 'addressNotAvailableModal',
  alreadyInUse: 'alreadyInUse',
  isExist: 'isExist'
};
export var resultPopupActionButton = [POPUP_STATE.addressRequestForm, POPUP_STATE.alternativeTariff, POPUP_STATE.shortSuccess, POPUP_STATE.fail, POPUP_STATE.addressNotAvailableModal, POPUP_STATE.alreadyInUse, POPUP_STATE.isExist];

/** Маска для поля ввода квартиры.
 * Согласно ТЗ пользователь должен иметь возможность вводить не более 4-х символов */
export var flatMask = {
  mask: '',
  format: '####'
};